module.exports = __webpack_public_path__ + "fonts/Lato-Bold.a2fb219c.eot";